export const CONTRACT_HIERARCHY_FILTER_KEYS = {
  USERS: "users",
  HIERARCHY_VIEW_TYPE: "hierarchyViewType",

  CONTRACT_SITUATIONS: "situations",
  CONTRACT_MODALITIES: "modalities",
  CONTRACT_DURATIONS: "durations",

  DATE_COLUMN: "dateColumn",
  START_DATE: "startDate",
  END_DATE: "endDate",

  ORDER_BY: "orderBy",
  SORT: "sort",
};
